import React, { useEffect, useState } from "react";
import './CoverageCardView.css';
import Card from 'react-bootstrap/Card';
import CheckboxComponent from "../CheckBox";
import Button from "../Button";
import PlusSvgIcon from '../../../assets/svg/plus.svg';
import MinusSvgIcon from '../../../assets/svg/minus.svg';
import InfoBar from "../InfoBars";

interface ListItem {
    id: any;
    name: string;
    code:string | number;
    
}
interface CoverageCardProps {
    listItems: ListItem[];
    labelforCoverage:string;
    colorCode?:string
}

const CoverageCardViewComponent: React.FC<CoverageCardProps> = ({ listItems,labelforCoverage, colorCode }) => {
    const [linkedFacilities, setLinkedFacilities] = useState(listItems);
    useEffect(() => {
        setLinkedFacilities(listItems && Array.isArray(listItems) ? listItems : []);
    }, [listItems]);
    return (
        <div className="coverage-card-component">
            <label className="label-name-css">{labelforCoverage}</label>
            <Card className="coverage-card-container" >
                <Card.Body className="coverage-card-body">
                    {linkedFacilities.map((item) => (
                        <div key={item.id} style={{color:colorCode ? colorCode : "#af2d94"}}>
                            {item.name}
                        </div>
                    ))}
                </Card.Body>
            </Card>
       
        </div >
    )
}
export default CoverageCardViewComponent;